// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep ngb-accordion .card-body {
  padding: 0 !important;
}
::ng-deep ngb-accordion .card-header {
  margin-top: 10px !important;
}
::ng-deep ngb-accordion .card {
  background-color: #ECECEC !important;
  border: none !important;
}
::ng-deep ngb-accordion .btn {
  padding: 0.625rem 0.75rem;
  font-size: 0.875rem;
  line-height: 0.75rem;
  font-weight: 400;
}
::ng-deep ngb-accordion .btn [class*=icon-] {
  color: inherit;
  line-height: inherit;
}
::ng-deep ngb-accordion .gray {
  color: white !important;
  background-color: #585857 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/additional-content/additional-content-list/additional-content-list.component.scss"],"names":[],"mappings":"AAGI;EACE,qBAAA;AAFN;AAII;EACE,2BAAA;AAFN;AAII;EACE,oCAAA;EACA,uBAAA;AAFN;AAII;EACE,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAFN;AAIM;EACE,cAAA;EACA,oBAAA;AAFR;AAMI;EACE,uBAAA;EACA,oCAAA;AAJN","sourcesContent":["@import \"../../../../styles/global/colors\";\n::ng-deep {\n  ngb-accordion {\n    .card-body {\n      padding: 0 !important;\n    }\n    .card-header {\n      margin-top: 10px !important;\n    }\n    .card {\n      background-color: $interviews-alt-light-gray !important;\n      border: none !important;\n    }\n    .btn {\n      padding: 0.625rem 0.75rem;\n      font-size: 0.875rem;\n      line-height: 0.75rem;\n      font-weight: 400;\n\n      [class*=\"icon-\"] {\n        color: inherit;\n        line-height: inherit;\n      }\n    }\n\n    .gray {\n      color: white !important;\n      background-color: $interviews-gray !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
